module.exports = __webpack_public_path__ + "img/classroomConnect.922e8363.png";